
import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import BarChartView from '../share/BarChartView';
import SharedTools from '../../lib/SharedTools';
import { Spin } from 'antd';
import { hashHistory } from 'react-router';

export default class UsageReportPage extends React.Component {

  static propTypes = {
      // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
     // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      classGrades: null,
      schoolId: props.params.schoolId,
      gradeId: 1,
      classId: null,
      year: new Date().getFullYear(),
      month: new Date().getMonth()+1,
      data: [
        {teachers_title: '老师平均发送照片', parents_title: '家长平均发送照片', type: 'photos', items: [], TeachersAverage: 0, ParentsAverage: 0},
        {teachers_title: '老师平均发送视频', parents_title: '家长平均发送视频', type: 'videos', items: [], TeachersAverage: 0, ParentsAverage: 0},
        {teachers_title: '老师平均发送成长档案', parents_title: '家长平均发送成长档案', type: 'archives', items: [], TeachersAverage: 0, ParentsAverage: 0},
      ],
      type: '',
      loadding: true
    };
    // bind this
    this.selectGrade = this.selectGrade.bind(this);
    this.changeMonth = this.changeMonth.bind(this);
    this.getUsageData = this.getUsageData.bind(this);
  }

  componentWillMount() {
    let that = this;
    let type = (this.state.currentRole.associatName === 'school' || this.state.currentRole.associatName === 'system') ? 'school_report' : this.state.currentRole.associatName === 'classGrade' ? 'grade_report' : '';
    if(type == 'school_report') {
      let school_id = this.state.schoolId;
      DataService.getAllClassGrade(school_id).then(Grade => {
        let classGrades =[];
        Grade.forEach((item) => {
          if (!item.is_graduated) {
            classGrades.push({
              id: item.id,
              name: item.grade_name,
              selected: false,
            })
          }
        })
        classGrades[0].selected = classGrades.length > 0 ? true : false ;
        let gradeId = classGrades[0].id;
        let data = {
          grade_id: gradeId,
          year: this.state.year,
          month: this.state.month
        };
        that.getUsageData(data)
        that.setState({
          classGrades: classGrades,
          gradeId: gradeId,
          type: type,
        });
      }).then((err) => {
        if(err) {
          console.log(err)
        }
      });
    }else if(type == 'grade_report') {
      let data = {
        grade_id: this.state.currentRole.associatObj.id,
        year: this.state.year,
        month: this.state.month
      };
      that.getUsageData(data)
      this.setState({
        gradeId: this.state.currentRole.associatObj.id,
        type: type,
      })
    }
  }

  componentDidUpdate() {
    this.refs.usageReport.style.width = this.state.data[0].items.length > 10 ? '850px' : '600px';
  }

  selectGrade(e) {
    var gradeId = e.currentTarget.dataset.id;
    var classGrades = this.state.classGrades;
    classGrades.map((grade) => {
      if (grade.id == gradeId) {
        grade.selected = true;
      } else {
        grade.selected = false;
      }
    })
    let data = {
      grade_id: gradeId,
      year: this.state.year,
      month: this.state.month
    };
    this.getUsageData(data);
    this.setState({
      classGrades: classGrades,
      gradeId: gradeId
    })
  }

  changeMonth(e) {
    let month, year;
    if (e.currentTarget.dataset.key == 'add') {
        month = this.state.month == 12 ? 1 : (this.state.month + 1);
        year = this.state.month == 12 ? (this.state.year + 1) : this.state.year;
    } else {
      month = this.state.month == 1 ? 12 : (this.state.month - 1);
      year = this.state.month == 1 ? (this.state.year - 1) : this.state.year;
    }
    let data = {
      grade_id: this.state.gradeId,
      year: year,
      month: month
    };
    this.getUsageData(data);
    this.setState({
      year: year,
      month: month,
    })
  }

  getUsageData(data) {
    let that = this;
    DataService.getUsageData(data).then(res => {
      for (var item in res) {
        let data = that.state.data.find((data) => data.type == item);
        data.items = res[item];
        // data.total = 0;
        if (res[item].length > 0) {
          var parent_total = 0;
          var teacher_total = 0;
          res[item].forEach((class_record) => {
            parent_total += class_record.parent_count;
            teacher_total += class_record.teacher_count;
          })
          data.TeachersAverage = (teacher_total % res[item].length == 0) ? (teacher_total / res[item].length) : (teacher_total / res[item].length).toFixed(1);
          data.ParentAverage = (parent_total % res[item].length == 0) ? (parent_total / res[item].length) : (parent_total / res[item].length).toFixed(1);
        }
      }
      that.setState({
        data: that.state.data,
        loadding: false
      })
    }).then((err) => {
      if(err) {
        console.log(err);
      }
      that.setState({
        loadding: false
      })
    })
  }

  handleClickBar = (classId, className) => {
    let {schoolId, year, month} = this.state;
    hashHistory.push(`school-admin/schools/${schoolId}/usage-report/classes/${classId}?className=${className}&year=${year}&month=${month}`);
  }

  render() {
    let className = '';
    if (this.state.classGrades) {
      className = this.state.classGrades.length > 1 ? ' col-' + this.state.classGrades.length : '';
    }
    return (
      <div className="usage-report-page" ref="usageReport">
        {this.state.loadding &&
        <div className="spinner">
          <Spin size="large" />
        </div>
        }

        {!this.state.loadding &&
        <div>
          {this.state.type == 'school_report' &&
          <div className="grade-list clearfix">
            {this.state.classGrades.map((grade) =>
              <div className={"grade" + className} key={grade.id} >
                <span className={"grade-name" + (grade.selected ? ' selected' : '')} onClick={this.selectGrade} data-id={grade.id}>{grade.name}</span>
              </div>
            )}
          </div>
          }

          <div className="current-month">
            <span className="left-icon" onClick={this.changeMonth} data-key="subtract"></span>
            <span className="month">{SharedTools.monthToString(this.state.month)}月<span className="month-detail">({this.state.year}.{this.state.month}.1 - {this.state.year}.{this.state.month}.{SharedTools.formatDate(this.state.year, this.state.month)})</span></span>
            <span className="right-icon" onClick={(this.state.year == (new Date().getFullYear()) && this.state.month == (new Date().getMonth()+1)) ? null : this.changeMonth} data-key="add"></span>
          </div>

          <div className="title">
            <div className="role teacher-role">老师发送情况</div>
            <div className="role parent-role">家长发送情况</div>
          </div>

          {this.state.data.map((data, index) =>
            <div className="chart-container" key={index}>
            <div className="count">
              <div className="teacher_count">
                {data.teachers_title}<span className="count-detail">{data.TeachersAverage}</span>
                <span>{data.type == "photos" ? '张' : data.type == "videos" ? "条" : data.type == "archives" ? "页" : ""}</span>
              </div>
              <div className="parent_count">
                {data.parents_title}<span className="count-detail">{data.ParentAverage}</span>
                <span>{data.type == "photos" ? '张' : data.type == "videos" ? "条" : data.type == "archives" ? "页" : ""}</span>
              </div>
            </div>
              <BarChartView data={data.items} type={data.type} classId={this.state.classId} style="transition: 1s" handleClickBar={this.handleClickBar}/>
          </div>)
          }
        </div>
        }
      </div>
    )}
}




// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/UsageReportPage.jsx